import { types } from 'mobx-state-tree'
import { ModelStore } from '@shared/data-access'
import { Model, MODEL_NAME } from './model'

export const Store = ModelStore.named(`${MODEL_NAME}Store`).props({
  url: '/unavailable_slots',
  map: types.map(Model),
})

export default Store
